class HomeView {
  faders = document.querySelectorAll(".fade-in");
  sliders = document.querySelectorAll(".slide-in");
  btnContactUs = document.querySelector(".btn-contact-us");
  btnCloseContact = document.querySelector(".btn-close-contact");
  contactUsForm = document.querySelector(".form-contact");
  // btnCloseNav = document.querySelector(".btn-close-nav");
  btnMenu = document.querySelector(".menu-mobile");
  nav = document.querySelector(".list-nav");

  appearOnScroll() {
    let options = {
      threshold: 0.5,
      // rootmargin: "0px 0px -500px 0px",
    };

    if (!window.innerWidth < 413) {
      options = {
        threshold: 0.1,
      };
    }

    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("appear");
        observer.unobserve(entry.target);
      });
    }, options);

    this?.faders.forEach((fader) => {
      observer.observe(fader);
    });

    this?.sliders.forEach((slider) => {
      observer.observe(slider);
    });
  }

  contactUsBtn() {
    this.btnContactUs?.addEventListener("click", () => {
      this.contactUsForm.classList.add("appear");
    });

    this.btnCloseContact?.addEventListener("click", () => {
      this.contactUsForm.classList.remove("appear");
    });
  }

  mobileMenu() {
    this.btnMenu?.addEventListener("click", () => {
      this.nav.classList.toggle("hidden-mobile");
    });

    // this.btnCloseNav.addEventListener("click", () => {
    //   this.nav.classList.add("hidden-mobile");
    // });
  }
}

export default new HomeView();
